import { EventInterface } from "../../../../../shop/frontend/web/js/interfaces/EventInterface";
import { EventView } from "../views/EventView";
import { eventHelper } from "../../../../../shop/frontend/web/js/helpers/EventHelper";
import { EVENT_ORDER } from "../../../../../shop/frontend/web/js/constants/event";
import { helpers } from "../../../../../shop/frontend/web/js/helpers";
import { EventInteractPlan } from "../components/EventInteractPlan/EventInteractPlan";
import { EventOrderBottom } from "../components/EventOrderBottom/EventOrderBottom";
import { arrayHelper } from "../../../../../shop/frontend/web/js/helpers/ArrayHelper";
import api from "../../../../../shop/frontend/web/js/api";
import { checkLongText } from "../components/longText";

class EventController extends EventInterface {
	constructor() {
		super();

		/* Объявляем компоненты */
		this.interactPlan = new EventInteractPlan();
		this.eventOrderBottom = new EventOrderBottom();

		/* Создаем представления */
		this.view = new EventView();

		/* Инициализация событии */
		super.initEventEmitter();
	}

	/* Инициализция подписчиков */
	setUpSubscribers() {
		checkLongText();
		/**
		 * Подписчик который срабатывает после загрузки мероприятия
		 * @event EventController#event:after-load-event
		 */
		this.emitter.subscribe("event:after-load-event", () => {
			/* добавляем в модель информацию об евенте */
			this.model.setEventId($("#js-places").data("event"));
			this.model.unitId = $("#js-svg").data("unit");

			if ($("#js-places").attr("data-show-free-places") === "0") {
				this.model.settings.showFreePlaces = false;
			}

			if ($("#js-places").attr("data-show-child-ticket-info") === "true") {
				this.view.showChildTicketInfo();
			}

			if (
				(window.location.pathname.includes("event") || window.location.search.includes("id_event")) && 
				!helpers.isDesktop.matches
			) {
				this.view.showEventOnPopup();
			}

			if (EVENT_ORDER) {
				this.eventOrderBottom.updateOrder(EVENT_ORDER, this.model.getEventId());
			}

			if (eventHelper.isStadiumPlan()) {
				return this.emitter.emit("event:load-stadium-plan");
			} else {
				return this.emitter.emit("event:load-scene-plan");
			}
		});

		/**
		 * Подписчик который нициализирует стадион
		 * @event EventController#event:load-stadium-plan
		 */
		this.emitter.subscribe("event:load-stadium-plan", () => {
			api.event.getZones({ eventId: this.model.getEventId() }).then(res => {
				if (!res.zones) return alert("Не удалось получить ценовые зоны!");

				this.model.zones = arrayHelper.convertObjectToArray(res.zones);
				this.model.zones = this.model.removeZeroPriceZones(this.model.zones);

				this.interactPlan.renderStadiumZones(this.model.zones, {
					showFreePlaces: this.model.settings.showFreePlaces,
				});

				/* Обработчик для фильтра по легендам цен */
				$(".js-stadium-zones input[type=checkbox]").on("change", () =>
					this.interactPlan.renderSvgSectorsByPrices()
				);
			});

			/* Инициализируем работу с планом стадиона */
			this.interactPlan.initStadiumPlan({
				model: {
					eventId: this.model.getEventId(),
					unitId: this.model.unitId,
				},
				settings: {
					showFreePlaces: this.model.settings.showFreePlaces,
				},
				onLoadSector: () => {
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				},
				tapOnPlace: place => this.emitter.emit("event:tap-on-place", place),
			});
		});

		/**
		 * Подписчик который срабатывает после загрузки сцены, зала
		 * т.е свг план у которого нет секторов! (не стадион)
		 * @event EventController#event:load-scene-plan
		 * @property sceneData {Object} - {prices, zones}
		 */
		this.emitter.subscribe("event:load-scene-plan", () => {
			api.event
				.getPrices({ eventId: this.model.getEventId(), viewId: this.model.currentViewId })
				.then(res => {
					if (!res.prices) return alert("Не удалось загрузить цены!");

					$("#js-places").addClass("active");
					$("#js-places-info").removeClass("places__info_sector");

					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());

					this.interactPlan.initScenePlan({
						model: {
							eventId: this.model.getEventId(),
							unitId: this.model.unitId,
							prices: res.prices,
							zones: res.zones,
						},
						settings: {
							showFreePlaces: this.model.settings.showFreePlaces,
						},
						tapOnPlace: place => this.emitter.emit("event:tap-on-place", place),
					});
				});
		});

		/**
		 * При нажатии на активное место добавляет или удаляет из корзины и возвращает событие
		 * @event EventController#event:tap-on-place
		 * @property {SVGGElement} $activePlace
		 */
		this.emitter.subscribe("event:tap-on-place", $activePlace => {
			const sid = $activePlace.attr("id");

			/* Если место уже активное то удаляем из корзины */
			if ($activePlace.attr("data-available") === "false")
				return this.emitter.emit("event:remove-from-cart", sid);

			return this.emitter.emit("event:add-to-cart", sid);
		});

		/**
		 * Удаляет место из корзины
		 * @event EventController#event:remove-from-cart
		 */
		this.emitter.subscribe("event:remove-from-cart", sid => {
			return api.eventCart
				.removeFromCart({
					eventId: this.model.eventId,
					sid: sid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.error) return alert("Произошла ошибка при удалении из корзины!");
					if (res.redraw)
						return alert("Данное место больше недоступно. Выберите другое. ");
					if (!res.carts) return false;

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();

					this.eventOrderBottom.removeActiveCarts(res.carts);
					this.interactPlan.removeActivePlaces(res.carts);
				})
				.catch(err => alert("Произошла ошибка при удалении из корзины!"));
		});

		/**
		 * Подписчик который добавляет место в корзину
		 * @event EventController#event:add-to-cart
		 */
		this.emitter.subscribe("event:add-to-cart", sid => {
			api.eventCart
				.addToCart({
					eventId: this.model.eventId,
					sid: sid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.need_auth) return alert("Необходима авторизация!");
					if (res.limit)
						return alert(
							"Вы превысили максимально допустимое количество мест для брони"
						);
					if (res.redraw)
						return alert("Данное место больше недоступно. Выберите другое. ");

					/* Обновляем счетчик корзины */
					window.CartService.count = window.CartService.count + 1;
					window.CartService.updateCount();

					$('#js-bottom-pane').removeClass('disable');
					
					/* Выводим заказ */
					this.eventOrderBottom.updateOrder(res.order, this.model.getEventId());
					/* Показываем активные места на плане */
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при добавлении в корзину!\n${err.message}`);
				});
		});

		/**
		 * Делает запрос на очистку корзины
		 * @event EventController#event:clear-cart
		 */
		this.emitter.subscribe("event:clear-cart", () => {
			api.eventCart
				.removeEventFromOrder({
					eventId: this.model.eventId,
					orderId: this.eventOrderBottom.getOrderId(),
				})
				.then(res => {
					if (res.error) return alert(res.msg ? res.msg : "Неизвестная ошибка!");

					if (res.refresh) return window.location.reload();

					if (!res.success) return alert("Произошла ошибка при очистке корзины!");

					/* Очищаем активные места на плане */
					this.interactPlan.removeActivePlaces(this.eventOrderBottom.getOrderCarts());

					/* Очищаем корзину */
					this.eventOrderBottom.clearOrder();
				})
				.catch(err => alert("Произошла ошибка при очистке корзины!"));
		});

		/**
		 * Делает запрос на изменение типа билета
		 * @event EventController#event:change-price-id
		 */
		this.emitter.subscribe("event:change-price-id", e => {
			const $elem = $(e.currentTarget);
			const orderId = $elem.attr("data-order-id");
			const eventId = $elem.parents(".tickets__item").attr("data-event");
			const uid = $elem.parents(".tickets__item").attr("data-uid");
			const priceId = $elem.attr("data-price-id");

			api.eventCart
				.changePriceId({ eventId, orderId, uid, priceId })
				.then(res => {
					if (res.error) throw new Error(res.msg || "");

					$elem.attr("data-price-id", $elem.attr("data-current-price-id"));
					$elem.attr("data-current-price-id", priceId);
					let carts = this.eventOrderBottom.getOrderCarts();

					carts.forEach(item => {
						res.carts.forEach(el => {
							if (item.id == el.id) {
								item.price_id = el.price_view_id;
								item.price_view_id = el.price_view_id;
							}
						});
					});

					const obj = {
						...res,
						id: res.order_id,
						amount: res.summ,
						carts,
					};

					this.eventOrderBottom.updateOrder(obj, Number(eventId));
					this.toggleTicketPriceId($elem);
					this.updateSum(eventId, res);
				})
				.catch(err => {
					console.log(err);

					if (err.message && err.message === "Требуется хотя бы один взрослый билет!") {
						$("#js-alert-modal").find(".modal-body").html(`
						<h3>Ошибка!</h3>
						<p class="mb-0">Для покупки детского абонемента необходимо <br> оформить хотя бы 1 взрослый абонемент</p>
					`);
						$("#js-alert-modal").modal();
						if (!helpers.isDesktop.matches) {
							$(".js-bottom-pane-move").trigger("click");
						}
						$(".body").removeClass("modal-open");
						return false;
					}

					alert(`Произошла ошибка!\n${err.message}`);
				});
		});
	}

	/* Инициализция обработчиков */
	setUpListeners() {
		this.eventOrderBottom.on("clear", () => this.emitter.emit("event:clear-cart"));
		this.eventOrderBottom.on("remove-ticket", sid =>
			this.emitter.emit("event:remove-from-cart", sid)
		);

		this.eventOrderBottom.on("change-price-id", e =>
			this.emitter.emit("event:change-price-id", e)
		);

		if (!helpers.isDesktop.matches) {
			this.eventOrderBottom.pane("show", () =>
				$("#js-places-change").css("padding-bottom", "138px")
			);
			this.eventOrderBottom.pane("hide", () =>
				$("#js-places-change").css("padding-bottom", "0")
			);
		}

		$(window).resize(() => {
			if (!window.matchMedia("(min-width: 768px)").matches)
				return this.view.showEventOnPopup();

			if (this.view.$popupModal.hasClass("modal_mobile-event"))
				return this.view.returnEventFromPopup();

			return true;
		});

		/* Инициализация страницы евента */
		this.emitter.emit("event:after-load-event");

		$(".js-places-more").on("click", e => {
			$(e.currentTarget).hide();
			$(".places__desc").toggle();
			$(".js-places-hide").show();
		});

		$(".js-places-hide").on("click", e => {
			$(e.currentTarget).hide();
			$(".places__desc").toggle();
			$(".js-places-more").show();
		});
	}

	toggleTicketPriceId($elem) {
		const switchName = $elem.attr("data-switch-name") || " ";
		const currentSwitchName = $elem.attr("data-current-switch-name") || " ";

		$elem.attr("data-switch-name", currentSwitchName);
		$elem.attr("data-current-switch-name", switchName);
		$elem.find("span").text(currentSwitchName);

		if (switchName === "Сделать детским") {
			$elem.parents(".tickets__item").addClass("tickets__item_child");
			$elem.removeClass("color-light-primary").addClass("color-light-green");
		} else {
			$elem.parents(".tickets__item").removeClass("tickets__item_child");
			$elem.removeClass("color-light-green").addClass("color-light-primary");
		}
	}

	updateSum(eventId, order) {
		$("#js-event-sum").text(order.summ);
		$(".js-sum").text(order.summ);
		const eventItem = $(`.js-order-event[data-event-id="${eventId}"]`);
		let currentOrderSum = 0;

		/* Проходим по каждому билету */
		$.each(order.active_carts[eventId].carts, (i, ticket) => {
			currentOrderSum += ticket.price;
			$(`.tickets__item[data-id=${ticket.id}]`).find(".js-ticket-price").text(ticket.price);
		});

		eventItem.find(".js-order-event-sum").text(currentOrderSum);
	}
}

export const eventController = new EventController();
